import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchFormerClientHistoryArgs,
  FetchProspectTicketsArgs,
  FetchProspectsArgs,
} from '../api/types/prospects.types';

import {
  fetchFormerClientHistory,
  fetchProspectTickets,
  fetchProspects,
} from '../api/prospects.api';

export const prospectsQueryKeys = createQueryKeys('prospects', {
  fetchProspects: (args: FetchProspectsArgs) => ({
    queryFn: () => fetchProspects(args),
    queryKey: [args.organizationId, args],
  }),
  fetchProspectTickets: (args: FetchProspectTicketsArgs) => ({
    queryFn: () => fetchProspectTickets(args),
    queryKey: [args.organizationId, args.prospectId],
  }),
  fetchFormerClientHistory: (args: FetchFormerClientHistoryArgs) => ({
    queryFn: () => fetchFormerClientHistory(args),
    queryKey: [args.organizationId, args.prospectId],
  }),
});
